import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchPrices = async () => (await api.get("/gold/prices")).data;
export const fetchNews = async () => (await api.get("/news")).data;
export const trackNewsClick = async (id) =>
    api.post(`/news/click/${id}`).catch(() => null);
